import { render, staticRenderFns } from "./ResultsPerPage.vue?vue&type=template&id=5494756a&scoped=true&"
import script from "./ResultsPerPage.vue?vue&type=script&lang=ts&"
export * from "./ResultsPerPage.vue?vue&type=script&lang=ts&"
import style0 from "./ResultsPerPage.vue?vue&type=style&index=0&id=5494756a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5494756a",
  null
  
)

export default component.exports